export const PEN_STRENGTHS: number[] = [2.5, 5, 7.5, 10, 12.5, 15];
export const CLICKS_PER_DOSE: number = 60;
export const DOSES_PER_PEN: number = 4;

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || ''; 

// External authoritative medical resources and brand statements for SEO/compliance
export const MEDICAL_LINKS = {
  eliLillyMounjaro: 'https://www.mounjaro.com/',
  fdaPrescribingInfo: 'https://www.accessdata.fda.gov/drugsatfda_docs/label/2022/215866s000lbl.pdf',
  tgaProductInfo: 'https://www.tga.gov.au/products/medicines/mounjaro',
  nhsGlp1Info: 'https://www.nhs.uk/medicines/semaglutide/',
};

export const LANDING_COPY = {
  heroTagline: 'Track your doses, weight & side effects. Save more, feel better.',
  heroCtaPrimary: 'Register free to track your progress',
  trustBadge: 'Join thousands of KwikPen users',
  benefits: [
    {
      title: 'Dose history & reminders',
      text: 'Never lose track of your medication schedule.',
    },
    {
      title: 'Weight & symptom journals',
      text: 'Visualize progress with simple charts and notes.',
    },
    {
      title: 'Cost savings analytics',
      text: 'See your spend per dose and reduce waste.',
    },
    {
      title: 'Ad-free experience',
      text: 'Create a free account to remove ads.',
    },
  ],
  howItWorks: [
    { title: 'Choose pen strength', text: 'Select your current KwikPen strength.' },
    { title: 'Count your clicks', text: 'Use the slider for precise fractional dosing.' },
    { title: 'Log your journey', text: 'Track doses, weight, and side effects.' },
    { title: 'See your progress', text: 'Spot trends and stay motivated.' },
  ],
  disclaimerTitle: 'Medical Disclaimer',
  disclaimerBody:
    'DoseWise is a tracking tool and does not provide medical advice. Always consult your healthcare provider for dosing decisions. Mounjaro® is a registered trademark of Eli Lilly.',
  finalCtaTitle: 'Start your free account',
  finalCtaSub: 'No credit card required. Export your data anytime.',
};